// extracted by mini-css-extract-plugin
export default {"SearchItem":"SearchItem_SearchItem__-jKnl","name":"SearchItem_name__ua6mM","date":"SearchItem_date__FPrzA"};